import React from 'react';
import styles from './CoreSeparator.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import formatStyles from '@/helpers/formatStyles';

let cx = className.bind(styles);

export default function CoreSeparator({ attributes }) {
	const styles = formatStyles(attributes.style);
	const className = attributes.className?.split(' ') || [];

	return <hr id={attributes.anchor} className={cx(['ns_separator', 'separator', ...className, attributes.backgroundColor && `border-color-${attributes.backgroundColor}`])} style={styles} />;
}

CoreSeparator.fragments = {
	key: `CoreSeparatorFragment`,
	entry: gql`
		fragment CoreSeparatorFragment on CoreSeparator {
			attributes {
				anchor
				backgroundColor
				style
			}
		}
	`,
};

CoreSeparator.config = {
	name: 'CoreSeparator',
};
CoreSeparator.displayName = 'CoreSeparator';
